import { Controller } from '@hotwired/stimulus';

import { FOCUSABLE_SELECTOR, slideToggle, trapFocus } from '@/modules/menu_effects';

export default class extends Controller {
  static targets = ['pull', 'wrapper'];

  connect() {
    this.releaseFocusTrap = null;
  }

  close() {
    this.#collapse();

    this.pullTarget.focus();
  }

  dismiss() {
    if (this.#opened) this.#collapse();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }

  open() {
    this.pullTarget.classList.add('ice-menu__pull--open');

    this.pullTarget.setAttribute('aria-expanded', 'true');
    this.pullTarget.setAttribute('aria-label', this.pullTarget.dataset.closeLabel);

    slideToggle({ content: this.wrapperTarget });

    this.releaseFocusTrap = trapFocus(this.wrapperTarget);

    this.wrapperTarget.querySelector(FOCUSABLE_SELECTOR)?.focus({ preventScroll: true });

    this.dispatch('open');
  }

  toggle(event) {
    event.stopPropagation();

    this.#opened ? this.close() : this.open();
  }

  #collapse() {
    this.pullTarget.classList.remove('ice-menu__pull--open');

    this.pullTarget.setAttribute('aria-expanded', 'false');
    this.pullTarget.setAttribute('aria-label', this.pullTarget.dataset.openLabel);

    slideToggle({ content: this.wrapperTarget });

    this.releaseFocusTrap?.();
    this.releaseFocusTrap = null;
  }

  get #opened() {
    return this.pullTarget.classList.contains('ice-menu__pull--open');
  }
}
